"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _helpButton = _interopRequireDefault(require("../../../../core/help-button"));
var _waitingListHelp = _interopRequireDefault(require("./waiting-list-help"));
var _entriesTable = _interopRequireDefault(require("../entries-table"));
var _exportEntries = _interopRequireDefault(require("../entry-action-buttons/export-entries"));
var _sendGroupEmail = _interopRequireDefault(require("../entry-action-buttons/send-group-email"));
var _waitingListManagement = _interopRequireDefault(require("../entry-action-buttons/waiting-list-management"));
var _cancelEntry = _interopRequireDefault(require("../entry-action-buttons/cancel-entry"));
var _promotionManagement = _interopRequireDefault(require("../entry-action-buttons/promotion-management"));
var _SwitchSession = _interopRequireDefault(require("../entry-action-buttons/SwitchSession"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("th", null);
var _ref2 = /*#__PURE__*/_react.default.createElement("p", null, "Loading...");
var _ref3 = /*#__PURE__*/_react.default.createElement("p", null, "You do not have access to this page");
var _ref4 = /*#__PURE__*/_react.default.createElement("h2", null, "Waiting List");
var _ref5 = /*#__PURE__*/_react.default.createElement(_helpButton.default, null, /*#__PURE__*/_react.default.createElement(_waitingListHelp.default, null));
class ManageWaitingList extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_renderExtraColumnHeadings", () => {
      return _ref;
    });
    _defineProperty(this, "_renderExtraColumns", entry => {
      return /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_waitingListManagement.default, {
        entry: entry
      }), /*#__PURE__*/_react.default.createElement(_cancelEntry.default, {
        entry: entry
      }), /*#__PURE__*/_react.default.createElement(_promotionManagement.default, {
        entry: entry
      }), /*#__PURE__*/_react.default.createElement(_SwitchSession.default, {
        entry: entry
      }));
    });
  }
  render() {
    if (!this.props.loaded) return _ref2;
    const competition = this.props.competition;
    if (!competition.isAdministratedByUser) return _ref3;
    return /*#__PURE__*/_react.default.createElement("div", null, _ref4, _ref5, /*#__PURE__*/_react.default.createElement(_exportEntries.default, {
      name: "waiting-list",
      competitionSlug: this.props.match.params.competitionSlug,
      yearID: this.props.match.params.yearID,
      useFreeCode: competition.useFreeCode
    }, "Export Waiting List"), /*#__PURE__*/_react.default.createElement(_sendGroupEmail.default, {
      entryGroup: "Waiting List Entries",
      entries: competition.waitingList,
      competitionName: competition.competitionName,
      organiserEmail: competition.organiserEmail,
      competitionDivisions: competition.competitionDivisions,
      competitionDays: competition.competitionDays,
      entryTypeOverrides: competition.entryTypeOverrides,
      races: competition.races
    }), /*#__PURE__*/_react.default.createElement(_entriesTable.default, {
      useFreeCode: competition.useFreeCode,
      entries: competition.waitingList,
      renderExtraColumns: this._renderExtraColumns,
      renderExtraColumnHeadings: this._renderExtraColumnHeadings
    }));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref6 = _mergeBqlQueries({
  isAdministratedByUser: true,
  useFreeCode: true,
  waitingList: _mergeBqlQueries(_mergeBqlQueries(_mergeBqlQueries(_mergeBqlQueries(_mergeBqlQueries(_mergeBqlQueries({
    id: true,
    canEnterFromWaitingList: true,
    competitionDivision: {
      isFreeToEnter: true
    }
  }, _entriesTable.default.partialQueries.Entry), _cancelEntry.default.partialQueries.Entry), _promotionManagement.default.partialQueries.Entry), _waitingListManagement.default.partialQueries.Entry), _sendGroupEmail.default.partialQueries.Entry), _SwitchSession.default.partialQueries.Entry)
}, _sendGroupEmail.default.partialQueries.Competition);
var _default = exports.default = (0, _reactBicycle.connect)(ManageWaitingList, props => ({
  ["competition(competitionSlug:" + JSON.stringify(props.match.params.competitionSlug) + ",yearID:" + JSON.stringify(+props.match.params.yearID) + ")"]: _ref6
}), undefined, {
  renderLoading: true
});